import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from 'antd';

import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { selectPhotosType, updatePhotoSorting } from '../../store/slices/sensors';
import { OrderAscValue, OrderDesValue } from './constants/index.jsx';
import { BreakpointMobileUp } from '../../constants/ui';
import { useViewport } from '../../hooks';

const FilterPhoto = ({ t }) => {
  const dispatch = useDispatch();
  const { widthViewport } = useViewport();

  const {
    sortingPhoto: { dir },
    photosType,
  } = useSelector((state) => state.sensors);

  const [filterOrder, setFilterOrder] = useState(dir === 'des' ? OrderDesValue : OrderAscValue);

  const onChangeOrder = ({ target: { value } }) => {
    dispatch(updatePhotoSorting({ dir: value === OrderAscValue ? 'asc' : 'des' }));
    setFilterOrder(value);
  };

  const onChangePhotoType = ({ target: { value } }) => {
    dispatch(selectPhotosType(value))
  };

  return (
    <div className={`${styles.filter} ${styles.filterNoNav}`}>
      {/*Order*/}
      <Radio.Group
        defaultValue={filterOrder}
        value={filterOrder}
        buttonStyle="solid"
        optionType="button"
        size={widthViewport < BreakpointMobileUp ? 'large' : null}
        onChange={onChangeOrder}
        className={`${styles.radioButtonGroup} ${styles.radioButtonGroupWide}`}
      >
        <Radio.Button
          value={OrderAscValue}
          className={`${styles.radioButton} ${filterOrder === OrderAscValue ? styles.radioButtonChecked : ''}`}
        >
          <span className={styles.radioButtonText}>
            <CroplerIcon name="asc" />
            {t('filters.ascending')}
          </span>
        </Radio.Button>
        <Radio.Button
          value={OrderDesValue}
          className={`${styles.radioButton} ${filterOrder === OrderDesValue ? styles.radioButtonChecked : ''}`}
        >
          <span className={styles.radioButtonText}>
            <CroplerIcon name="desc" />
            {t('filters.descending')}
          </span>
        </Radio.Button>
      </Radio.Group>

      {/*Photo Types*/}
      <Radio.Group
        defaultValue={photosType}
        buttonStyle="solid"
        optionType="button"
        className={`${styles.radioButtonGroup}`}
        size={widthViewport < BreakpointMobileUp ? 'large' : null}
        onChange={onChangePhotoType}
      >
        <Radio.Button
          value={'day'}
          className={`${styles.radioButton}  ${photosType === 'day' ? styles.radioButtonChecked : ''}`}
        >
          <span className={styles.radioButtonText}>
            <CroplerIcon name="day" />
            {t('filters.day')}
          </span>
        </Radio.Button>
        <Radio.Button
          value={'night'}
          className={`${styles.radioButton}  ${photosType === 'night' ? styles.radioButtonChecked : ''}`}
        >
          <span className={styles.radioButtonText}>
            <CroplerIcon name="night" />
            {t('filters.night')}
          </span>
        </Radio.Button>
        <Radio.Button
          value={'ndvi'}
          className={`${styles.radioButton}  ${photosType === 'ndvi' ? styles.radioButtonChecked : ''}`}
        >
          <span className={styles.radioButtonText}>NDVI</span>
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default FilterPhoto;
